<template>
    <div class="search-input-field">
        <ui-model-provider v-model="currentValue" v-slot="{ value, updateValue, updateValueRaw }">
            <ui-input type="search"
                    :facets="['base', 'search', 'large']"
                    :value="value"
                    v-bind="$attrs"
                    @input="updateValue">
                <template slot="actions">
                    <button type="submit"
                            :aria-label="searchLabel"
                            :title="searchLabel"
                            class="search-input-field--button">
                        <ui-icon symbol="search" size="medium"/>
                    </button>
                    <button type="button"
                            class="search-input-field--button"
                            v-if="value"
                            @click="updateValueRaw('')">
                        <ui-icon symbol="close" :size="clearIconSize"/>
                    </button>
                </template>
            </ui-input>
        </ui-model-provider>
    </div>
</template>

<script>
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider.vue';
    import UiInput from '@dreipol/vue-ui/src/components/form/input/input.vue';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import isMobileMixin from 'framework/mixins/is-mobile';

    export default {
        components: {
            UiInput,
            UiIcon,
            UiModelProvider,
        },
        mixins: [isMobileMixin],
        props: {
            value: {
                type: String,
                required: true,
            },
            searchLabel: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                currentValue: this.value,
            };
        },
        computed: {
            clearIconSize() {
                return this.isMobile ? 'small' : 'medium';
            },
        },
    };
</script>
